import * as React from "react";
import { Box } from "@material-ui/core";
import { CheckboxStates } from "hooks/SharedGrid/useTableCheckbox";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import CheckBoxIconEmpty from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import CheckboxFewChecked from "@material-ui/icons/IndeterminateCheckBoxOutlined";

type GridWithPaginationCheckboxProps = {
  checkboxState: CheckboxStates;
  onCheckboxClick: () => void;
};

const ICONS_MAP = {
  [CheckboxStates.checked]: CheckBoxIcon,
  [CheckboxStates.unchecked]: CheckBoxIconEmpty,
  [CheckboxStates.partial]: CheckboxFewChecked
};

export function GridWithPaginationCheckbox(
  props: GridWithPaginationCheckboxProps
): React.ReactElement {
  const { checkboxState, onCheckboxClick } = props;
  const Icon = ICONS_MAP[checkboxState];

  if (!Icon) {
    return null;
  }

  return (
    <Box sx={{ cursor: "pointer", marginRight: "0.5rem", display: "flex" }}>
      <Icon onClick={onCheckboxClick} />
    </Box>
  );
}
